import React from 'react';
import { useHistory } from 'react-router-dom';

import useStoreTranslation from 'hooks/useStoreTranslation';
import ResponseScreen, { BackgroundTypes } from 'screens/components/ResponseScreen';
import { IconTypes } from 'screens/components/ResponseScreen/components/Icon';
import { htmlT } from 'utils/generic';

import { SuccessText } from './styles';

type Props = {
  show: boolean;
  travelId?: string;
};

const ExpensesSuccess = ({ show, travelId }: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();

  const handleButtonClick = () => {
    if (travelId) history.push(`/expenses/${travelId}`);
  };

  return (
    <ResponseScreen
      show={show}
      background={BackgroundTypes.Cloud}
      text={t('expensesSuccess.title')}
      subText={<SuccessText>{htmlT(t, 'expensesSuccess.text')}</SuccessText>}
      buttonOnClick={handleButtonClick}
      icon={IconTypes.Airplane}
    />
  );
};

export default ExpensesSuccess;
